<template>
  <div class="contract-summary">
    <div class="contract-summary__title ms-help">
      Итого по проекту
    </div>
    <i-table
      border
      :columns="columns"
      :data="summary"
    />
  </div>
</template>

<script>
import { getFormattedCosts, round } from '@/utils'

const columns = [
  {
    title: 'Наименование',
    key: 'name'
  },
  {
    title: 'Стоимость по договору, руб',
    key: 'costs',
    width: 208,
    render: (h, params) => {
      return h('b', getFormattedCosts(params.row.costs, true))
    }
  },
  {
    title: 'Сумма поступившей оплаты (в т.ч. аванс), руб',
    key: 'payments_value',
    width: 208,
    render: (h, params) => {
      return h('b', getFormattedCosts(params.row.payments_value, true))
    }
  },
  {
    title: 'Процент поступившей оплаты, %',
    key: 'payment_part',
    width: 172,
    render: (h, params) => {
      return h('b', round(params.row.payment_part * 100, 1))
    }
  }
]

export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      columns
    }
  },
  computed: {
    summary () {
      const { customer, contragent } = this.project

      return [
        { ...customer, name: 'Основной договор' },
        ...contragent.map(c => ({ ...c, name: c.contragent_name }))
      ]
    }
  }
}
</script>

<style lang="less">
.contract-summary {
  &__title {
    font-size: 12px;
    margin-bottom: 8px;
    text-transform: uppercase;
  }
}
</style>
